var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.challengeLocked && (_vm.narratives.length === 0 || _vm.completedChallengeOutroNarrative))?_c('div',{staticClass:"lock-message"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.unlockMessage)}})]):_c('narrative-player',{attrs:{"narratives":_vm.narratives,"on-complete":_vm.onComplete}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32767f06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/pages/ChallengeOutro.vue
// module id = null
// module chunks = 